var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BannerTable',{attrs:{"bannersType":"default","partnerId":_vm.partnerId,"banners":_vm.defaultBanners,"loading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }